module.exports = __webpack_public_path__ + "img/appAsset-brand--Airtable.ccf12f57.svg";